import * as React from 'react';

import type {ComparedActivityReportSummary, ReportRowData} from 'nutshell-core/types';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';

import {ReportSummaryTable} from '../report-summary-table';
import {getReportSegmentAggregate} from '../report-utils';

type Props = {
    data: ComparedActivityReportSummary<Array<ReportRowData>> | null | undefined;
    hasError: boolean;
    isLoading: boolean;
};

export function EmailReportSummaryTable(props: Props) {
    const {data} = props;

    // Get group names
    const groupNames =
        data && data.currentPeriod && data.currentPeriod[0] && data.currentPeriod[0].segments
            ? data.currentPeriod[0].segments.map((segment) => segment.title)
            : [];

    const columns = [
        {
            Header: 'User',
            id: 'user',
            accessor: (currentPeriod: any) => currentPeriod.title, // This is the user name
            dataType: 'component',
            minWidth: 175,
            width: 175,
            maxWidth: 225,
            hasRightBorder: true,
            hasLeftBorder: true,
            shouldTruncate: true,
            Footer: 'Totals',
            Cell: ({cell}: any) => <LinkedEntity name={cell.value} type='users' />,
        },
    ];

    // Add a column for each group
    groupNames.forEach((groupName) => {
        columns.push({
            Header: groupName,
            id: groupName,
            accessor: (currentPeriod: any) => currentPeriod,
            dataType: 'integer',
            minWidth: 175,
            width: 175,
            maxWidth: 225,
            // @ts-expect-error
            Footer: (tableData) => {
                return getReportSegmentAggregate(tableData.rows, groupName);
            },
            hasRightBorder: groupName === groupNames[groupNames.length - 1],
            // @ts-expect-error
            sortType: (rowA, rowB) => {
                const segmentA = rowA.values[groupName].segments.find(
                    // @ts-expect-error
                    (seg) => seg.title === groupName
                );
                const segmentB = rowB.values[groupName].segments.find(
                    // @ts-expect-error
                    (seg) => seg.title === groupName
                );

                return segmentA.totalsByReport[0].count.value >
                    segmentB.totalsByReport[0].count.value
                    ? 1
                    : -1;
            },
            Cell: ({cell}: any) => {
                const segment =
                    // @ts-expect-error
                    cell.value && cell.value.segments.find((seg) => seg.title === groupName);

                return segment.totalsByReport[0].count.value.toLocaleString();
            },
        });
    });

    return (
        <ReportSummaryTable
            // @ts-expect-error
            columns={columns}
            data={props.data}
            hasError={props.hasError}
            isLoading={props.isLoading}
            emptyStateText={{title: 'No emails sent', subtitle: 'Send emails to see them here'}}
        />
    );
}
